import { METHOD_PAGE_FAQ_ITEMS } from '../content/methodPageFaq';

/** FAQPage JSON-LD from the visible `/method` FAQ sections only. */
export function buildMethodFaqJsonLd(): unknown[] {
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: METHOD_PAGE_FAQ_ITEMS.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    },
  ];
}
